import { Map, GeoJSONSource } from 'maplibre-gl'
import { useEffect } from 'react'
import { TDriverLocation } from '../../../services/rides/rides'
import StandardCarPng from '../../../assets/map/standard.png'
interface IProps {
  map?: Map
  driver: TDriverLocation | null
}

export type TRenderCarMarker = (driver_location: TDriverLocation) => void;

const DriverLocation = ({ map, driver }: IProps) => {
  useEffect(() => {
    if (!map) return
    map.loadImage(StandardCarPng, (error, image) => {
      if (error) throw error
      map.addImage('car-marker', image as ImageBitmap)
    })

    map.addSource('current-location', {
      type: 'geojson',
      data: {
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: [0, 0]
        },
        properties: {
          heading: 0
        }
      }
    })

    map.addLayer({
      id: 'current-location-marker',
      source: 'current-location',
      type: 'symbol',
      layout: {
        'icon-image': 'car-marker',
        'icon-size': 0.4,
        'icon-padding': 1,
        'icon-allow-overlap': true,
        'icon-ignore-placement': true,
        'icon-rotate': { type: 'identity', property: 'heading' },
        'icon-rotation-alignment': 'map'
      }
    })
  }, [map])

  useEffect(() => {
    if (driver) {
      renderCarMarker(driver)
    } else {
      renderCarMarker({ lat: 0, lon: 0, heading: 0 })
    }
  }, [driver])

  const renderCarMarker: TRenderCarMarker = driver_location => {
    if (!map) return;
    (map.getSource('current-location') as GeoJSONSource)?.setData({
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [driver_location.lon, driver_location.lat]
      },
      properties: {
        heading: driver_location.heading
      }
    })
  }

  return null
}

export default DriverLocation

